import {computed, ref, watch} from 'vue'

export default class SecurityProvider {
	constructor(router, store) {
		this.router = router
		this.store = store
		this.to = ref(null)
		this.userWatch = null
		this.role = null
	}

	setupWatchers () {
		if (!this.userWatch) {
			const user = computed(() => this.store.state.user)
			this.userWatch = watch(user, (newUser, oldUser) => {
				this.role = newUser.role
				const redirect = this.redirect()
				if (redirect !== null) {
					this.router.push(redirect)
				}
			}, { immediate: true, deep: true, once: false })
		}
	}

	redirect () {
		let redirect = null
		if (this.to) {
			for (const record of this.to.matched.filter(record => record.meta)) {
				if (this.isAuthRequiredAndFailed(record)) {
					redirect = this.redirectWithFunctionOrDefault(
						record, to => ({name: 'Login', query: {redirect: to.fullPath}})
					)
					break
				} else if (this.isRouteForbiddenByRole(record)) {
					redirect = this.redirectWithFunctionOrDefault(
						record, (to) => ({ path: '/' })
					)
					break
				} else if (this.isRedirectObject(record)) {
					redirect = record.meta.redirect[this.role] || null
					if (redirect !== null) {
						break
					}
				}
			}
		}
		if (redirect === null) {
			return redirect
		} else {
			return redirect(this.to)
		}
	}

	resolve (to, from, next) {
		this.to = to
		this.setupWatchers()
		const redirect = this.redirect()
		if (redirect === null) {
			next()
		} else {
			next(redirect)
		}
	}

	redirectWithFunctionOrDefault (record, defaultValue) {
		if (record.meta.redirect && record.meta.redirect.constructor === Function) {
			return record.meta.redirect
		} else {
			return defaultValue
		}
	}

	isRedirectObject (record) {
		return record.meta.redirect && record.meta.redirect.constructor === Object
	}

	isAuthRequiredAndFailed (record) {
		return record.meta.requiresAuth && (this.role === 'unauthorized' || this.role === 'guest')
	}

	isRouteForbiddenByRole (record) {
		return record.meta.requiresRole && (
			(record.meta.requiresRole.constructor === String && record.meta.requiresRole !== this.role) ||
			(record.meta.requiresRole.constructor === Array && !record.meta.requiresRole.includes(this.role))
		)
	}
}
